/**
 * 店舗の詳細ページのルートコンポーネント
 * 
 * テンプレートはJinjaの以下と紐づく
 * templates/organizations/{...}/point.html > templates/default/point.html
 */
import { defineComponent } from 'vue'
import PointPage from "@/organizations/_default/point"
import PointSearchConditions from "@/components/common/PointSearchConditions.vue"
import { Filters } from '@/services/Filters.ts'
import { overrideCommon } from './common.js'

// マップ・リスト・詳細共通の上書き処理
overrideCommon()

export default defineComponent({
  extends: PointPage,
  components: {PointSearchConditions},
  setup(props, context) {
    const page = PointPage.setup(props, context)

    /**
     * 検索条件の件数を取得
     * @returns {number} 検索条件の数
     */
    const getConditionsCount = () => {
      const uniqueNames = new Set()
      return Filters
        .getPointFilters(
          Filters.TYPE_SEARCH_CONDITIONS,
          page.point.value,
          Filters.getFilterTree(Filters.TYPE_SEARCH_CONDITIONS)
        )
        // 表示されている検索条件のみを取得
        .filter(condition => condition.is_show)
        // 親が表示されている場合のみ取得
        .filter(condition => {
          const parent = Filters.findParentById(Filters.TYPE_SEARCH_CONDITIONS, condition.id)
          if (!parent?.is_show) {
            return false
          }     
          return true
        })
        .reduce((count, condition) => {
          if (!uniqueNames.has(condition.name)) {
            uniqueNames.add(condition.name)
            return count + 1
          }
          return count
        }, 0)
    }

    /**
     * 店舗の持つ有効な検索条件の件数
     * @type {number}
     */
    const conditionsCount = getConditionsCount()

    return {
      ...page,
      conditionsCount,
    }
  }
})